// extracted by mini-css-extract-plugin
export default {"modal":"OnBoardingModal_modal__i5pa9","modalDialog":"OnBoardingModal_modalDialog__iVHQr","modalContent":"OnBoardingModal_modalContent__n2-UC"};